class ReactFilterDate extends React.Component {

    constructor(props) {
        super(props);
        ModulesMixinsOutsideClick._composite(this);
        this.state = {
            isActive: false,
            isExpanded: false,
            more: props.settings.more,
            less: props.settings.less,
            equal: props.settings.equal,
            preset: props.settings.preset
        }
    }

    /**
     * TODO: Fix cdm not being called (maybe this is related to call the class using eval in Grid.jsx:1482)
     */
    componentDidMount() {
        if(!this.afterRenderFired) {
            this.afterRender();
        }
    }

    afterRender() {
        var me = this;

        if(!this.afterRenderFired) {

            if (this.refs.more_field) {
                var moreField = $(ReactDOM.findDOMNode(this.refs.more_field));
                moreField.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "c-100:c+100",
                    onSelect: function () {
                        me.setState({more: this.value});
                    }
                });
                moreField.css('z-index', 100);
            }

            if (this.refs.less_field) {
                var lessField = $(ReactDOM.findDOMNode(this.refs.less_field));
                lessField.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "c-100:c+100",
                    onSelect: function () {
                        me.setState({less: this.value});
                    }
                });
                lessField.css('z-index', 100);
            }

            if (this.refs.equal_field) {
                var equalField = $(ReactDOM.findDOMNode(this.refs.equal_field));
                equalField.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "c-100:c+100",
                    onSelect: function () {
                        me.setState({equal: this.value});
                    }
                });
                equalField.css('z-index', 100);
            }

            if (this.state.preset) {
                this.showRightPanel();
            }

            me.afterRenderFired = true;

        }
    }

    getValues() {
        this.setState({isActive: this.state.more || this.state.less || this.state.equal || this.state.preset ? true : false});
        return this.state;
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.setState({
            isActive: false,
            more: null,
            less: null,
            equal: null,
            preset: null
        });
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        this.setState(values, function () {
            if (values.preset) {
                this.showRightPanel();
            } else {
                this.showLeftPanel();
            }
        }.bind(this));
    }

    clearFilter() {
        this.clearValues();
        if (this.props.loadGrid) {
            setTimeout(function () {
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    /**
     * Called by "OutsideClick" Mixin to handle outside click
     */
    outsideClickHandle(e) {
        if (!$('.ui-datepicker').is(":visible")) {
            this.setState({
                isExpanded: false
            });
        }
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if (event.target.dataset.button == "apply") {
            this.props.applyFilters();
        }
        if (event.target.dataset.button == "clear") {
            this.props.clearFilters();
        }
    }

    showRightPanel(event) {

        var el = $(ReactDOM.findDOMNode(this));

        el.find('.secondary-title').show('slide', {direction: 'right'}, 500);
        el.find('.secondary-content').show('slide', {direction: 'right'}, 500);

        el.find('.primary-title').hide();
        el.find('.primary-content').hide();
    }

    showLeftPanel(event) {

        var el = $(ReactDOM.findDOMNode(this));

        el.find('.primary-title').show('slide', {direction: 'left'}, 500);
        el.find('.primary-content').show('slide', {direction: 'left'}, 500);

        el.find('.secondary-title').hide();
        el.find('.secondary-content').hide();

        this.setState({preset: null});
    }

    onMoreChange(event) {
        this.setState({more: event.target.value});
    }

    onLessChange(event) {
        this.setState({less: event.target.value});
    }

    onEqualChange(event) {
        this.setState({equal: event.target.value});
    }

    onPresetClick(event) {
        this.setState({
            preset: $(event.target).data('preset'),
            isExpanded: false
        });
        if (this.props.loadGrid) {
            setTimeout(function () {
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    render() {

        var props = this.props;
        var state = this.state;

        var fields = [];

        if (props.settings.type == 'between' || props.settings.type == 'more') {
            fields.push(
                <div key="more-field" className="field-holder field-with-icon-holder calendar input-datepicker-holder">
                    <input ref="more_field" type="text" value={state.more} onChange={this.onMoreChange.bind(this)}
                           placeholder={__d('modules','From')} className="datepicker jquery-ui-datepicker"/>
                </div>
            );
        }

        if (props.settings.type == 'between' || props.settings.type == 'less') {
            fields.push(
                <div key="less-field" className="field-holder field-with-icon-holder calendar input-datepicker-holder">
                    <input ref="less_field" type="text" value={state.less} onChange={this.onLessChange.bind(this)}
                           placeholder={__d('modules','To')} className="datepicker jquery-ui-datepicker"/>
                </div>
            )
        }

        if (props.settings.type == 'equal') {
            fields.push(
                <div key="equal-field" className="field-holder field-with-icon-holder calendar input-datepicker-holder">
                    <input ref="equal_field" type="text" value={state.equal} onChange={this.onEqualChange.bind(this)}
                           placeholder={__d('modules','Equal To')} className="datepicker jquery-ui-datepicker"/>
                </div>
            )
        }

        var presets = [];

        this.props.presets.forEach(function (val, i) {
            presets.push(
                <div key={'preset-' + val.alias}
                     className={'custom-range ' + (i % 2 == 0 ? 'odd' : 'even') + (this.state.preset == val.alias ? ' selected' : '')}
                     data-preset={val.alias} onClick={this.onPresetClick.bind(this)}>{val.name}</div>
            );
        }.bind(this));

        var holderCls = 'btn-group custom-dropdown-wrapper custom-dropdown-wrapper-multi-content';
        if (this.state.isActive) {
            holderCls += ' active';
        }

        if (this.state.isExpanded) {
            holderCls += ' expanded';
        }

        var buttons = null;
        if (this.props.applyFilters && this.props.clearFilters) {
            buttons = (
                <div className="grid-filter-actions">
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="apply"
                       className="btn btn-primary apply-filter" role="button">{__d('modules','Apply')}</a>
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="clear"
                       className="btn btn-link clear-filter" role="button">{__d('modules','Reset')}</a>
                </div>
            );
        }

        setTimeout(()=>{
            this.afterRender();
        },200);

        return (
            <div className={holderCls}>
                <div className="custom-dropdown-button">
                    <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle"
                            ref="outside_click_trigger" onClick={this.togglePopup.bind(this)}
                            data-toggle="custom-dropdown" aria-haspopup="true" aria-expanded="false">
                        {props.label}
                    </button>
                </div>
                <div className="custom-dropdown-clear-button">
                    <button type="button" className="btn btn-primary clear-filter"
                            onClick={this.clearFilter.bind(this)}><i/></button>
                </div>
                <div className="card custom-dropdown-popup custom-dropdown-popup-date" ref="outside_click_content"
                     id="custom-dropdown-popup-date">
                    <div className="card-header">
                        <div className="title primary-title" onClick={this.showRightPanel.bind(this)}>
                            <span>{__d('modules','Date Presets')}</span> <i className="pull-right"/></div>
                        <div className="title secondary-title" onClick={this.showLeftPanel.bind(this)}><i/>
                            <span>{__d('modules','Back')}</span></div>
                        <div className="clearfix"></div>
                    </div>

                    <div className="card-block">
                        <div className="content primary-content">
                            <div className="title">{__d('modules','Custom Range')}</div>
                            {fields}
                            {buttons}
                        </div>
                        <div className="content secondary-content">
                            {presets}
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactFilterDate.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};

ReactFilterDate.defaultProps = {
    settings: {
        more: null,
        less: null,
        equal: null,
        preset: null
    },
    presets: [
        {alias: 'today', name: __d('modules','Today')},
        {alias: 'yesterday', name: __d('modules','Yesterday')},
        {alias: 'current_week', name: __d('modules','Current Week')},
        {alias: 'current_month', name: __d('modules','Current Month')},
        {alias: 'current_quarter', name: __d('modules','Current Quarter')},
        {alias: 'current_ytd', name: __d('modules','Current YTD')},
        {alias: 'previous_week', name: __d('modules','Previous Week')},
        {alias: 'previous_month', name: __d('modules','Previous Month')},
        {alias: 'previous_quarter', name: __d('modules','Previous Quarter')},
        {alias: 'previous_year', name: __d('modules','Previous Year')}
    ]

};